import { trpc } from "../trpc";
import { useToggleZap } from "./useToggleZap";

interface Input {
  folderId?: string; // used for cache invalidation
}

export function useEnableZap(input?: Input) {
  const { folderId } = input || {};

  const { handleMutation, handleSettled, handleSuccess } = useToggleZap({
    folderId,
  });

  const mutation = trpc.zap.enable.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: () => {
      handleMutation();
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: handleSettled,
    onSuccess: (zap) => {
      handleSuccess({
        zapId: (zap as any)?.zapId || zap?.id || "",
        enable: true,
      });
    },
  });

  return {
    enableZap: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
